import { render, staticRenderFns } from "./ScreeningCreate.vue?vue&type=template&id=2dc11b7c&scoped=true&"
import script from "./ScreeningCreate.vue?vue&type=script&lang=js&"
export * from "./ScreeningCreate.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningCreate.vue?vue&type=style&index=0&id=2dc11b7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc11b7c",
  null
  
)

export default component.exports